import { render, staticRenderFns } from "./ShowQuiz.vue?vue&type=template&id=6a960053&scoped=true&"
import script from "./ShowQuiz.vue?vue&type=script&lang=js&"
export * from "./ShowQuiz.vue?vue&type=script&lang=js&"
import style0 from "./ShowQuiz.vue?vue&type=style&index=0&id=6a960053&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a960053",
  null
  
)

export default component.exports